import { render, staticRenderFns } from "./VisitaControloEcgList.vue?vue&type=template&id=07a76328"
import script from "./VisitaControloEcgList.vue?vue&type=script&lang=js"
export * from "./VisitaControloEcgList.vue?vue&type=script&lang=js"
import style0 from "./VisitaControloEcgList.vue?vue&type=style&index=0&id=07a76328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports